// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.char-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  color: #fff;
  background-color: #0a56ae;
}

.tag-border {
  border-style: dashed;
  border-width: 0 0 1px 0;
  align-items: flex-start;
  border-color: #aeccef;
}

.new-tag {
  background-color: #0a56ae;
  color: #fefefe;
  font-size: 10px;
  padding: 2px 5px;
  border-radius: 3px;
  margin-right: 5px;
  margin-left: 3px;
  margin-right: 3px;
}

.account-name-row {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 5px;
}

.job-info-row {
  display: flex;
  flex-direction: row;
  gap: 15px;
}

.job-info-text {
  font-size: 12px;
  color: #000000;
  font-weight: 500;
}

.column-display {
  display: flex;
  flex-direction: column;
}

.work-location-text {
  font-weight: 700;
  color: #807f7f;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./../job/src/components/JobListing/JobTagCanvas.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;AACF;;AAEA;EACE,oBAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AACF","sourcesContent":[".char-circle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  color: #fff;\n  background-color: #0a56ae;\n}\n\n.tag-border {\n  border-style: dashed;\n  border-width: 0 0 1px 0;\n  align-items: flex-start;\n  border-color: #aeccef;\n}\n\n.new-tag {\n  background-color: #0a56ae;\n  color: #fefefe;\n  font-size: 10px;\n  padding: 2px 5px;\n  border-radius: 3px;\n  margin-right: 5px;\n  margin-left: 3px;\n  margin-right: 3px;\n}\n\n.account-name-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: center;\n  gap: 5px;\n}\n\n.job-info-row {\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n}\n\n.job-info-text {\n  font-size: 12px;\n  color: #000000;\n  font-weight: 500;\n}\n\n.column-display {\n  display: flex;\n  flex-direction: column;\n}\n\n.work-location-text {\n  font-weight: 700;\n  color: #807f7f;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
